import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { getAvatarUrl, getFullName } from '../../core/pipes/user/user.functions';

@Component({
  selector: 'user-label',
  template: `<div title="{{name}}"><img class="pull-left avatar" style="margin-right: .5em;" [ngClass]="class" [src]="url" />
  <span style="padding-top: 2px;"
      class="truncate-text">{{name}}</span></div>`
})
export class UserLabelComponent implements OnChanges {
  @Input('img-size') imgSize: string = 'sm';
  @Input() fullName: boolean = true;
  @Input() user: any = {};

  protected name: string = '';
  protected class: string = '';
  protected url: string = '';

  ngOnChanges(changes: SimpleChanges): void {
    this.class = 'avatar-' + this.imgSize;
    this.url = getAvatarUrl(this.user);
    this.name = this.fullName ? 
      getFullName(this.user) :
      this.user?.unixName;
  }
}